import { CheckCircleIcon } from '@heroicons/react/24/outline';

const WhySection = () => {
  return (
    <div className="py-20 px-4 bg-muted/30">
      <div className="container mx-auto">
        <div className="max-w-5xl mx-auto">
          {/* Stat as context, not fear */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
              The Numbers Tell a Story. We're Changing the Ending.
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              These statistics describe the world as it is today. SeniorThrive exists
              to help you write a different outcome.
            </p>
          </div>

          {/* Statistics Cards, stat + the bright-side pivot */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-card rounded-md p-8 text-center shadow-raised hover:shadow-overlay transition-shadow">
              <div className="text-4xl md:text-5xl font-bold text-primary mb-3">14M</div>
              <div className="text-lg font-bold text-foreground mb-2">Falls at Home Each Year</div>
              <p className="text-muted-foreground mb-4">Most caused by hazards that were already there, just never noticed.</p>
              <p className="text-primary font-bold text-sm">SeniorThrive spots them room by room, before they become a problem.</p>
            </div>

            <div className="bg-card rounded-md p-8 text-center shadow-raised hover:shadow-overlay transition-shadow">
              <div className="text-4xl md:text-5xl font-bold text-primary mb-3">95%</div>
              <div className="text-lg font-bold text-foreground mb-2">Want to Stay Home</div>
              <p className="text-muted-foreground mb-4">Nearly every older adult wants to age in their own home. The tools to do it safely haven't kept up.</p>
              <p className="text-primary font-bold text-sm">We built a system that makes staying home the confident choice.</p>
            </div>

            <div className="bg-card rounded-md p-8 text-center shadow-raised hover:shadow-overlay transition-shadow">
              <div className="text-4xl md:text-5xl font-bold text-primary mb-3">53M</div>
              <div className="text-lg font-bold text-foreground mb-2">Family Caregivers</div>
              <p className="text-muted-foreground mb-4">Millions of adult children support aging parents, often from a distance, often alone.</p>
              <p className="text-primary font-bold text-sm">SeniorThrive gives families a shared view so no one carries the weight alone.</p>
            </div>
          </div>

          {/* The pivot, what we do differently */}
          <div className="bg-gradient-to-br from-primary/5 to-accent/10 rounded-lg p-8 md:p-12 shadow-raised">
            <h3 className="text-2xl md:text-3xl font-bold text-foreground text-center mb-6">
              We Saw a Gap. We Built a Bridge.
            </h3>
            <p className="text-lg text-muted-foreground text-center leading-relaxed max-w-3xl mx-auto mb-8">
              Most solutions for aging at home are reactive, they alert you after something goes wrong.
              SeniorThrive is proactive. We help you prevent problems, track progress, and stay connected,
              so that independence at home feels natural and supported.
            </p>
            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {[
                'Prevention over reaction, spot risks before they become emergencies',
                'One connected system, not a patchwork of apps, devices, and phone calls',
                'Family coordination with independence, everyone aligned, no one hovering'
              ].map((point, i) => (
                <div key={i} className="flex items-start gap-3">
                  <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                  <p className="text-foreground leading-relaxed">{point}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhySection;
